<template>
  <UiLink
    v-lazy-background="imageSrc"
    :to="getNewsItemUrl(slug || link)"
    class="relative flex h-[370px] w-[241px] flex-col overflow-hidden rounded-xl bg-cover bg-center md:h-[340px] md:w-[224px] lg:h-[500px] lg:w-[324px]"
  >
    <span
      v-if="tags && tags.length"
      class="absolute left-6 right-6 top-6 z-10 flex flex-wrap gap-2"
    >
      <UiTag v-for="(tag, ti) in tags" :key="ti" color="white" static>
        <span v-html="tag" />
      </UiTag>
    </span>

    <span class="z-10 mt-auto bg-gradient-to-t from-slate-darker2/80 p-6 pt-12">
      <h3
        class="title text-xl uppercase leading-none text-white"
        v-html="title"
      />
    </span>
  </UiLink>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMediaAsset } from '~/composables';
import { handleImageSrc } from '~/helpers';

interface Props {
  slug?: string;
  link?: string;
  title?: string;
  image?: any;
  tags?: any[];
}

const props = withDefaults(defineProps<Props>(), {
  slug: '',
  link: '',
  title: '',
  image: '',
  tags: () => [],
});

const { getAssetUrl } = useMediaAsset();

const imageSrc = computed(() => getAssetUrl(handleImageSrc(props.image)));

const isExternalLink = (link = '') => /^https?:/.test(link);

const getNewsItemUrl = (url?: string) => {
  if (url) return isExternalLink(url) ? url : `/${url.replace(/^\/+/, '')}`;
  return false;
};
</script>
